import { useState, useSyncExternalStore } from 'react';
import { pwaInstallStore } from '@/lib/pwaInstallStore';

const isIOSDevice = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

const isAndroidDevice = () => /android/i.test(navigator.userAgent);

const isStandaloneDisplay = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  (navigator as unknown as { standalone?: boolean }).standalone === true;

export const usePwaInstall = () => {
  const { canInstall, isInstalled } = useSyncExternalStore(
    pwaInstallStore.subscribe,
    pwaInstallStore.getSnapshot
  );
  const [isIOS] = useState(isIOSDevice);
  const [isAndroid] = useState(isAndroidDevice);
  const [isStandaloneAtMount] = useState(isStandaloneDisplay);
  const isStandalone = isStandaloneAtMount || isInstalled;

  const promptInstall = async (): Promise<'accepted' | 'dismissed' | 'unavailable'> => {
    const deferredPrompt = pwaInstallStore.consumeDeferredEvent();
    if (!deferredPrompt) return 'unavailable';

    await deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    return outcome;
  };

  return { canInstall, isStandalone, isIOS, isAndroid, promptInstall };
};
